const sections = document.querySelectorAll("[data-faq-sections]");
const navLi = document.querySelectorAll("[data-faq-group-list] li");
window.addEventListener("scroll", () => {
  let current = "";
  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.clientHeight;
    if (scrollY >= sectionTop - sectionHeight / 3) {
      current = section.getAttribute("id");
    }
  });

  navLi.forEach((li) => {
    li.classList.remove("active");
    if (li.classList.contains(current)) {
      li.classList.add("active");
    }
  });
});

document
  .querySelectorAll("[data-faq-list-toggle]")
  .forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      this.classList.toggle("active");
      let nextElement = this.nextElementSibling;
      if (nextElement && nextElement.classList.contains("accordion")) {
        nextElement.classList.toggle("faq-item");
      }
    });
  });
